// extracted by css-extract-rspack-plugin
export default {"divider":"PopoverList_divider__hKyCi","item":"PopoverList_item__AXzUk","itemText":"PopoverList_itemText__-1Hv4","primary":"PopoverList_primary__vKi-Q"};